import { render, staticRenderFns } from "./ExpertTasks.vue?vue&type=template&id=6790bf2f&scoped=true&lang=pug"
import script from "./ExpertTasks.vue?vue&type=script&lang=ts"
export * from "./ExpertTasks.vue?vue&type=script&lang=ts"
import style0 from "./ExpertTasks.vue?vue&type=style&index=0&id=6790bf2f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6790bf2f",
  null
  
)

/* custom blocks */
import block0 from "./RExpertTasks.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FWidgets%2FTasks%2FExpertTasks.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports